import React from 'react'
import TailoredServicesImage from "../../Assests/AboutUs/TailoredServicesImage.png"

function TailoredServices() {
  return (
    <div className='tailored-services-bg  py-5'>
        <div className='container pt-5 '>
                <div className='d-flex justify-content-center fw-bold missionandvisiontextcolor tailored-services-main-text' style={{fontSize:"4rem"}}>Tailored Services for You</div>
                <div className='row w-100'>
                    <div className='col-md-6'>
                    <div className='d-flex justify-content-center align-items-center'> 
                        <img src={TailoredServicesImage} style={{width:"100%"}} alt='TailoredServicesImage'/>
                    </div>
                    </div>
                    <div className='col-md-6 d-flex justify-content-center '>
                        <div className='p-2'>
                            <div className='mt-5 pt-5 tailored-services-content'>
                                <div className='fw-bold missionandvisiontextcolor fs-2 tailored-services-sub-text'>Door Step Sample Collection</div>
                                <div className='fs-4 mt-3 tailored-services-para-text'>Your safety is our priority. 
                                    We use the highest standards to collect your samples 
                                    ensuring a smooth, safe, and comfortable experience. 
                                    Every step of our process meets strict quality and safety guidelines.</div>
                            </div>

                            <div className='mt-5 pt-5 tailored-services-content'>
                                <div className='fw-bold missionandvisiontextcolor fs-2 pt-5 mt-2 tailored-services-sub-text'>Multiomics Analysis</div>
                                <div className='fs-4 mt-3 tailored-services-para-text'>We dive deep into the science of you! Our advanced multiomics 
                                    analysis examines various layers of your biological data such as genes, proteins, 
                                    microbes and metabolites, to give a full picture of your health. 
                                    This approach helps us to understand how your body works and 
                                    how could we personalize wellness solutions just for you.</div>
                            </div>

                            <div className='mt-5 pt-5 tailored-services-content'>
                                <div className='fw-bold missionandvisiontextcolor fs-2 pt-5 mt-4 tailored-services-sub-text'>Health Tracking with IoT Devices</div>
                                <div className='fs-4 mt-3 tailored-services-para-text'>Stay connected to your health with smart devices that track essential health metrics. 
                                    From heart rate to sleep patterns, our devices help monitor key areas of your health daily such that 
                                  you can always have the information you need to make quick decisions. </div>
                            </div>


                            <div className='mt-5 pt-5 tailored-services-content'>
                                <div className='fw-bold missionandvisiontextcolor fs-2 pt-5 mt-5 tailored-services-sub-text'>Multi-omics for Personalization</div>
                                <div className='fs-4 mt-3 tailored-services-para-text'>We leverage insights from your multi-omic test results to create 
                                    precision-tailored solutions that align with your unique biological profile. 
                                    This comprehensive analysis informs our strategies 
                                    ensuring that recommendations are both effective and customized to your individual needs.  </div>
                            </div>

                            <div className='mt-5 pt-5 tailored-services-content'>
                                <div className='fw-bold missionandvisiontextcolor fs-2 pt-5 mt-2 tailored-services-sub-text'>Personalized Nutrition</div>
                                <div className='fs-4 mt-3 tailored-services-para-text'>No more one-size-fits-all diets! 
                                    We create nutrition plans tailored to your unique needs based on your multiomics profile. 
                                    Our personalized nutrition guidance ensures you are getting the right nutrients 
                                    to support your body’s specific requirements. </div>
                            </div>

                            <div className='mt-5 pt-5 tailored-services-content'>
                                <div className='fw-bold missionandvisiontextcolor fs-2 pt-5 mt-5 tailored-services-sub-text'>Personalized Treatment Plan</div>
                                <div className='fs-4 mt-3 tailored-services-para-text'>We create tailored health plans based on your unique needs 
                                    from customized nutrition and fitness routines to stress management techniques and lifestyle adjustments, 
                                    which help you make meaningful changes for a healthier, balanced life. 
                                    Every step is designed to support your individual goals and well-being.</div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

    </div>
  )
}

export default TailoredServices